<script setup lang="ts"></script>

<template>
  <div class="login-bg">
    <div style="margin-right: auto; margin-left: auto">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-bg {
  background: url('@/assets/images/bg-login.jpg') center / cover no-repeat;
  position: relative;
  z-index: 1;
  min-height: 100vh;
}
.login-bg:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  height: 100%;
  width: 100%;
  background: #272727;
  opacity: 0.7;
}
</style>
